import Marquee from "react-fast-marquee";

export default function HeroMarquee({ children = "LEVEL UP · PURPLE REIGN · TEXAS KINGS · " }) {
    return (
        <Marquee speed={40} gradient={false} className="overflow-hidden">
            <span className="outline-text text-7xl md:text-9xl whitespace-nowrap px-6">
                {children.repeat(3)}
            </span>
        </Marquee>
    );
}
